import React, { FC } from 'react';
import { getSrcString, getSrcSetString } from './helpers/getSrcStrings';

type Props = {
    src: string;
    srcSetWidths?: number[];
    ariaHidden?: boolean;
    ariaLabelledBy?: string;
    className?: string;
    altText?: string;
    dataTn?: string;
    sizes?: string;
    // onLoad handler is passed down when ResponsiveImage is used within HpLazyImageWrapper/LazyImage
    onLoad?: () => void;
};

const ResponsiveImage: FC<Props> = ({
    altText,
    ariaHidden,
    ariaLabelledBy,
    className = '',
    src,
    srcSetWidths,
    dataTn,
    sizes,
    onLoad,
}) => {
    return (
        <img
            aria-hidden={ariaHidden === true || undefined}
            aria-labelledby={ariaLabelledBy}
            alt={ariaHidden && altText ? altText : undefined}
            className={className}
            data-tn={dataTn}
            src={getSrcString({ url: src })}
            srcSet={
                srcSetWidths
                    ? getSrcSetString({
                          url: src,
                          widths: srcSetWidths,
                      })
                    : undefined
            }
            sizes={sizes}
            onLoad={onLoad}
        />
    );
};

export default ResponsiveImage;
